import { useQuery } from '@tanstack/react-query';
import { getEvents } from '../../services/sportService';
import { isSuccess } from '../../common/serviceUtil';
import { useEventStore } from '../../store/event/eventStore';
import { useEntryStore } from '../../store/entry/entryStore';
import { useTranslation } from 'react-i18next';

export const useEventPoll = (eventGroupId?: number, marketCode?: string) => {
  const {
    i18n: { language },
  } = useTranslation();
  const setStore = useEventStore((s) => s.setStore);
  const entry = useEntryStore((s) => s.entry);
  const events = useEventStore((s) => s.events);

  const pastMarkets = events
    ?.filter((event) => event.eventStartTime < Date.now() && event.eventActive)
    .map((event) => {
      return event.markets.filter((market) => !market?.marketResulted);
    })
    .flat();

  return useQuery(
    ['getEvents', eventGroupId],
    ({ signal }) =>
      getEvents({
        eventGroupId,
        signal,
        marketCode,
        languageCode: language,
      }),
    {
      onSettled: (data, error) => {
        if (isSuccess(data)) {
          setStore(data.value);
          return;
        }
      },
      enabled: !!pastMarkets?.length && !!entry,
      refetchOnWindowFocus: false,
      //re-fetch data after this many milliseconds, if 0 don't re-fetch
      refetchInterval: Number(process.env.REACT_APP_EVENT_POLL_INTERVAL) || 2000,
    },
  );
};
